import { Typography } from '@material-ui/core'
import React from 'react'

import { gregorianToJalaaliWithHourMinuteAndSecond } from '../../../helpers/date'
import { lang } from '../../../localization'
import { ReservedField } from '../../../types/inventory'
import useStyles from './styles/modalRow'

interface ModalRowProps {
  data: ReservedField
  index: number
}

export const ModalRow: React.FC<ModalRowProps> = ({ data, index }) => {
  const classes = useStyles({ index })

  return (
    <div className={[classes.root, lang === 'fa' && classes.rootFa].join(' ')}>
      <div>
        <Typography className={classes.tableHeader} variant="h4">
          {data.CRSNumber}
        </Typography>
      </div>
      <div>
        <Typography className={classes.tableHeader} variant="h4">
          {data.version}
        </Typography>
      </div>
      <div>
        <Typography className={classes.tableHeader} variant="h4">
          {data.action}
        </Typography>
      </div>
      <div>
        <Typography className={classes.tableHeader} variant="h4">
          {gregorianToJalaaliWithHourMinuteAndSecond(data.createdAt)}
        </Typography>
      </div>
      <div>
        <Typography className={classes.tableHeader} variant="h4">
          {gregorianToJalaaliWithHourMinuteAndSecond(data.updatedAt)}
        </Typography>
      </div>
      <div>
        <Typography className={classes.tableHeader} variant="h4">
          {data.deletedAt
            ? gregorianToJalaaliWithHourMinuteAndSecond(data.deletedAt)
            : ''}
        </Typography>
      </div>
    </div>
  )
}
